import { ApplicationPaths } from "../models/enums/ApplicationPaths";
import { AppPrefix } from "./StringConstants";

export const MapApplicationPathToPathWithPrefix = (path: ApplicationPaths) => {
  return AppPrefix.concat("/", path);
};
